'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _containers = require('../../containers');






var _components = require('../../components');





var _checkUserAgent = require('../../utils/checkUserAgent');var _checkUserAgent2 = _interopRequireDefault(_checkUserAgent);
var _constants = require('../../constants');



var _helpers = require('../HomePage/helpers');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);

var _ForeignPropertypage = require('./ForeignPropertypage.scss');var styles = _interopRequireWildcard(_ForeignPropertypage);
var _WhatsAppWidget = require('../WhatsAppWidget/WhatsAppWidget');var _WhatsAppWidget2 = _interopRequireDefault(_WhatsAppWidget);

var _extractLocalisedData = require('../../helpers/extractLocalisedData');var _extractLocalisedData2 = _interopRequireDefault(_extractLocalisedData);
var _helpers2 = require('./helpers');var _helpers3 = _interopRequireDefault(_helpers2);
var _foreignPropertySearch = require('../../redux/modules/foreignPropertySearch');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Component
// Helpers
// Styles
var ForeignPropertyPage = function (_Component) {_inherits(ForeignPropertyPage, _Component);function ForeignPropertyPage(props) {_classCallCheck(this, ForeignPropertyPage);var _this = _possibleConstructorReturn(this, _Component.call(this, props));_initialiseProps.call(_this);
    _this.state = {
      isMobileOrTablet: _checkUserAgent2.default.isMobileOrTablet(navigator.userAgent) };return _this;

  }ForeignPropertyPage.prototype.

  componentWillUnmount = function componentWillUnmount() {
    this.props.clearForeignSearchData();
  };ForeignPropertyPage.prototype.








































































































  render = function render() {var
    langStatic = this.props.langStatic;
    var promoTitle = this.getPromotionTitle();

    return (
      _react2.default.createElement('div', { className: styles.home },
        this.renderHelmet(),
        _react2.default.createElement('div', { className: styles.wrapperTop },
          _react2.default.createElement('div', {
              className: styles.masthead },

            _react2.default.createElement(_components.Video, {
              isMobileOrTablet: this.state.isMobileOrTablet,
              isMobile: this.props.isMobile,
              locale: this.props.locale,
              imageLink: (0, _helpers3.default)(this.props.isMobile) }),


            _react2.default.createElement('div', { className: styles.wrapperSearch },
              _react2.default.createElement('div', { className: styles.title }, promoTitle),
              this.renderSearchContainer())),



          this.isCountryPage() && this.renderCountryLanding(),

          this.isSearchPage() && this.renderSearchResults(),

          _react2.default.createElement(_components.PlaceYourForeignProperty, null),
          this.isLandingPage() &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: styles.wrapperCountriesList },
              _react2.default.createElement('div', { className: styles.title },
                langStatic('countriesList', 'countriesListTitle')),

              _react2.default.createElement(_containers.CountriesListContainer, null)),

            this.renderCarouselList())),



        _react2.default.createElement(_WhatsAppWidget2.default, { translate: this.props.langStatic })));


  };return ForeignPropertyPage;}(_react.Component);var _initialiseProps = function _initialiseProps() {var _this2 = this;this.getCountryTag = function () {return (0, _get2.default)(_this2.props, 'routeData.optionType');};this.getCountryName = function () {var _props = _this2.props,searchedAddress = _props.searchedAddress,locale = _props.locale;var _ref = (0, _extractLocalisedData2.default)(searchedAddress || {}, locale) || {},_ref$country_name = _ref.country_name,country_name = _ref$country_name === undefined ? '' : _ref$country_name;return country_name;};this.getPromotionTitle = function () {var countriesCount = _this2.props.countriesList.length;var isCountry = _this2.isCountryPage() || _this2.isSearchPage();var countryName = _this2.getCountryName();var translationKey = isCountry ? 'country_main_promotion' : 'foreign_main_promotion';var value = isCountry ? countryName : countriesCount;return _this2.props.langStatic(translationKey).replace(/%s/, value);};this.isSearchPage = function () {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;return (0, _get2.default)(props, 'location.pathname', '').includes(_constants.ROUTES_ADDITIONAL.FOREIGN_SEARCH);};this.isCountryPage = function () {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;return !!_this2.getCountryTag() && !_this2.isSearchPage(props);};this.isLandingPage = function () {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;return !_this2.isCountryPage(props) && !_this2.isSearchPage(props);};this.renderCountryLanding = function () {var countryTag = _this2.getCountryTag();return _react2.default.createElement(_containers.ForeignPageCountryContainer, { country: countryTag });};this.renderSearchResults = function () {var countryTag = _this2.getCountryTag();return _react2.default.createElement(_containers.ForeignPropertiesListContainer, { country: countryTag, routeQuery: (0, _get2.default)(_this2.props, 'location.query', {}) });};this.renderSearchContainer = function () {var countryTag = _this2.getCountryTag();return _react2.default.createElement(_containers.ForeignSearchContainer, { country: countryTag });};this.renderCountryCarousel = function (country, idx) {var locale = _this2.props.locale;var countryName = (0, _get2.default)(country, 'name');var countryTitle = (0, _extractLocalisedData2.default)((0, _get2.default)(country, 'localisation', {}), locale);var className = !!(idx % 2) && styles.darkBackground;return _this2.renderProperties(countryName, countryTitle, className);};this.renderProperties = function (countryName, countryTitle, className) {var langStatic = _this2.props.langStatic;var translation = langStatic('foreignProperties', 'propertyIn');var title = translation.replace(/%s/, countryTitle);return _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.benefits, styles.carousel, className), key: countryName }, _react2.default.createElement('h2', null, title), _react2.default.createElement(_containers.ForeignPagePropertiesContainer, { carouselType: countryName // withPropertyTypesFilter // TODO Uncomment for chips
      }));};this.renderCarouselList = function () {return (_this2.props.countriesList || []).slice(0, 5).map(_this2.renderCountryCarousel);};this.renderHelmet = function () {var _props2 = _this2.props,location = _props2.location,locale = _props2.locale;var route = location.pathname;var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);return _react2.default.createElement(_reactHelmet2.default, { titleTemplate: _this2.props.langStatic('title', 'titleTemplate')(), title: _this2.props.langStatic('title', 'home')(), link: [].concat(multiLanguage, [{ rel: 'canonical', href: '' + _constants.shareUrl + (route === _helpers.ROOT_ROUTE ? '' : route) }]), meta: [{ property: 'og:url', content: '' + _constants.shareUrl + (route === _helpers.ROOT_ROUTE ? '' : route) }, { property: 'og:description', content: _this2.props.langStatic('helmet', 'homeOGDescription') }, { property: 'og:title', content: _this2.props.langStatic('helmet', 'homeTitle') + ' | \u202BOnMap' }, { name: 'description', content: _this2.props.langStatic('helmet', 'homeDescription') }] });};};exports.default = ForeignPropertyPage;

ForeignPropertyPage.propTypes = {
  location: _propTypes2.default.object,
  locale: _propTypes2.default.string,
  params: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  langStatic: _propTypes2.default.func,
  countriesList: _propTypes2.default.array,
  searchedAddress: _propTypes2.default.object,
  clearForeignSearchData: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ForeignPropertyPage/ForeignPropertyPage.js
// module id = 2690
// module chunks = 0